import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import WebApiRoutes from '@config/Routes/WebApiRoutes';
import WebApiGeneralRoutes from '@config/Routes/WebApiGeneralRoutes';

const baseQuery = fetchBaseQuery({
  baseUrl: WebApiRoutes.getBaseUrl(),
});

const AuditLogApi = createApi({
  reducerPath: 'AuditLogApi',
  baseQuery,
  endpoints: (builder) => ({
    getAuditLogs: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/logs`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAuditLogsActivities: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/activities`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAuditLogsActors: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/actors`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAuditLogsActorRoles: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/actor_roles`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAuditLogsObjects: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/objects`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAuditLogsObjectTypes: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/object_types`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
    getAuditLogsSources: builder.mutation({
      query: ({ accessToken, params }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/audit-log/sources`, params),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
  }),
});

export const {
  useGetAuditLogsMutation,
  useGetAuditLogsActivitiesMutation,
  useGetAuditLogsActorsMutation,
  useGetAuditLogsActorRolesMutation,
  useGetAuditLogsObjectsMutation,
  useGetAuditLogsObjectTypesMutation,
  useGetAuditLogsSourcesMutation,
} = AuditLogApi;

export default AuditLogApi;
